// extracted by mini-css-extract-plugin
module.exports = {"ResourceLabelsCard":"ResourceLabelsCard___2KiEh","ResourceLabelsCard_hasData":"ResourceLabelsCard_hasData___2tt5X"};